import { render, staticRenderFns } from "./CreateEditWorkspace.vue?vue&type=template&id=faf05b6e&scoped=true&"
import script from "./CreateEditWorkspace.vue?vue&type=script&lang=ts&"
export * from "./CreateEditWorkspace.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEditWorkspace.vue?vue&type=style&index=0&id=faf05b6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf05b6e",
  null
  
)

export default component.exports